<template>
  <vue-scroll>
    <div v-for="(agent, name) in remediations" :key="name">
      <span class="heading">
        <i class="fas fa-th-large window"></i>
        <h6>{{name}}</h6>
      </span>
      <ul class="list">
        <div class="value subtitle2" v-for="(rec, idx) in agent" :key="idx">
          <li v-if="$_.isString(rec)">{{rec}}</li>
          <li v-else :class="{'strikethrough': !rec.valid}">{{rec.recommendation}}</li>
        </div>
      </ul>
    </div>
  </vue-scroll>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RemediationRecFeed",
  props: {
    iocInfoList: {
      default: function() {
        return {};
      },
      type: [Array, Object]
    }
  },
  data() {
    return {
      remediations: {}
    };
  },
  methods: {
    getHostDetails(agentId) {
      let agentInfo = _.find(this.agentList.models, agent => {
        return agentId === agent.agentId;
      });
      if (agentInfo) {
        if (agentInfo.customHostname !== "UNNAMED") {
          return agentInfo.customHostname;
        }
        return agentInfo.agentLabel;
      }
      return agentId.split(".")[1];
    }
  },
  computed: {
    ...mapGetters(["agentList"])
  },
  watch: {
    /**
     * Recommendations will come in two flavors
     * a. list of recommendation strings
     * b. list of objects {recommendation: '', valid: true/false}
     */
    iocInfoList: function(newIocList, oldIocList) {
      if (newIocList !== oldIocList && !_.isEmpty(newIocList)) {
        this.remediations = _.chain(newIocList)
          .map(ioc => {
            if (ioc.recommendation && ioc.recommendation.length > 0) {
              return {
                agentId: ioc.agentId,
                agentIdLabel:
                  ioc.agentIdLabel || this.getHostDetails(ioc.agentId),
                recommendation: ioc.recommendation
              };
            }
          })
          .omitBy(_.isUndefined)
          .groupBy("agentIdLabel")
          .value();

        // flatten recommendation list for each host and remove duplicates
        for (let rec in this.remediations) {
          this.remediations[rec] = _.chain(this.remediations[rec])
            .map("recommendation")
            .flatten()
            .uniqWith(_.isEqual)
            .value();
        }
      }
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

section {
  height: calc(100%-50px);
}

div {
  flex-wrap: nowrap;
  padding: 0px;

  > .subtitle2,
  .value {
    align-self: auto;
  }
}

.window {
  padding: 7px 10px 0px 0px;
  font-size: 20px;
}

.heading {
  display: flex;
  background: #e9e9e9;
  padding: 5px 0px 5px 25px;
  margin: 15px 0px 15px 0px;
  border: 2px solid #d5d5d5;
  border-left: none;
}

.list {
  padding-right: 32px;
}

.strikethrough {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/feed/RemediationRecFeed.vue